import { Component, input } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import type { OnyxPhone } from '@onyx/angular';
import {
  OnyxPhoneNumberInputComponent,
  onyxPhoneValidator,
  OnyxSectionComponent,
} from '@onyx/angular';

type PhoneFormGroup = ReturnType<(typeof PhoneFormComponent)['buildForm']>;

@Component({
  selector: 'app-contact-form',
  imports: [
    OnyxSectionComponent,
    ReactiveFormsModule,
    OnyxPhoneNumberInputComponent,
  ],
  templateUrl: './phone-form.component.html',
  styleUrl: './phone-form.component.scss',
})
export class PhoneFormComponent {
  public readonly form = input.required<PhoneFormGroup>();

  protected readonly I18N = 'forms.phone';

  public static buildForm(fb: NonNullableFormBuilder, isOptional = false) {
    return fb.group({
      phone: fb.control<OnyxPhone | null>(null, [
        ...(!isOptional ? [Validators.required] : []),
        onyxPhoneValidator,
      ]),
    });
  }
}
